<template>
	<div class="Index">
		<Header :typeHeader="'indexHeader'" />
		<!-- 标题 -->
		<div class="indexCons">
			<div class="indexConsTop" >
				<module-title :title="  $store.state.navShow == true ? '国际供应链' : 'International supply chain'" EnglishTitle="SERVICE"></module-title>
				<el-carousel loop height="70"  :autoplay="autoplay1" indicator-position="none" arrow="never"
					ref="carousel" @change="indexCons">
					<img class="el-carousel__arrow el-carousel__arrow--left" src="../assets/Index/l.png"
						@click="setActiveItem(0)">
					<el-carousel-item class="indexConsTitle" v-for="(item,index) in $store.state.navShow == true ? mapRouteList : mapRouteListE" :key="index"
						name="item.id">
						<div class="indexConsTitleText">
							<div class="indexConsTitleText_1">{{ item.title }}</div>
							<div class="indexConsTitleText_2" :style="$store.state.navShow == true ? 'width: 90%;':'width: 60%;'">{{ item.text }}</div>
						</div>
					</el-carousel-item>
					<img class="el-carousel__arrow el-carousel__arrow--right" src="../assets/Index/r.png"
						@click="setActiveItem(1)">
				</el-carousel>
			</div>
			<div class="indexConsImg">
				<!-- <transition name="el-zoom-in-top"> -->
				<!-- <div class="indexConsShow" v-show="indexConsShow_1"> -->
				<div class="serviceContent">
					<div class="serviceContentCenter" ref="serviceContentCenter"
						:style="{ '--highPercentage': touchInfo.percentage + '%' }" @click="JupmPath()">
						<!-- 底图 -->
						<div class="imageContent BaseBannnr">
							<el-image :src=" $store.state.navShow == true ? Image.service.CentralRailway.default : Image.serviceE.CentralRailway.default" v-if="touchInfo.direction">
							</el-image>
							<el-image :src=" $store.state.navShow == true ? Image.service.OceanRail.default : Image.serviceE.OceanRail.default" v-else></el-image>
						</div>
						<!-- 高亮图 -->
						<div :class="['imageContent', 'highlightBanner', touchInfo.direction ? 'positive' : 'reverse']">
							<el-image :src="$store.state.navShow == true ? Image.service.CentralRailway.highlight : Image.serviceE.CentralRailway.highlight" v-if="touchInfo.direction">
							</el-image>
							<el-image :src="$store.state.navShow == true ? Image.service.OceanRail.highlight : Image.serviceE.OceanRail.highlight" v-else></el-image>
						</div>
						<!-- 高亮控件 -->
						<div :class="['highlightControl', touchInfo.direction ? 'positive' : 'reverse']"
							ref="highlightControl">
							<!-- 触摸块 -->
							<!-- @mousedown="touchStart" -->
							<div class="TouchTheBlock" @touchstart="touchStart($event)" @touchend="touchOver($event)">
								<el-image :src="Image.blueArrows"></el-image>
								<!--<el-image :src="Image.blueArrows"></el-image> -->
							</div>
						</div>
						<!-- </div> -->
					</div>


				</div>
			</div>

			<img class="indexConsShow_Img" :src="$store.state.navShow == true ? c1Image : c1Image_E" v-if="indexConsShow_1">
			<img class="indexConsShow_Img" :src="$store.state.navShow == true ? c2Image : c2Image_E" v-if="indexConsShow_2">
			<!-- 中俄运输 -->
			<div class="TransportationBetweenChinaAndRussia">
				<!-- banner -->
				<div class="banner">
					<el-image :src="Image.transportation"></el-image>
				</div>
				<!-- 文字详情 -->
				<div class="transportationContent" data-aos="zoom-in">
					<h1>{{$store.state.navShow == true ? '中俄运输' : 'Sino-Russian Transportation'}}</h1>
					<p>{{$store.state.navShow == true ? 'MG集团拥有中俄两国贸易进出口运输线' : 'Import and export transportation lines between China and Russia'}}</p>
					<el-button type="primary" round @click="$router.push('/CR_sinoRussianRailway')">
						<span>{{$store.state.navShow == true ? '了解详情' : 'Learn more'}}</span>
						<i class="el-icon-arrow-right el-icon--right"></i>
					</el-button>
				</div>
			</div>

			<module-title :title="$store.state.navShow == true ?'新闻中心':'Press Center'" EnglishTitle="NEWS"></module-title>
			<div class="indexNewsCon">
				<el-carousel class="headerBanner" @change="newBusiness" :height="newbBannerHeight + 'px'"
					:autoplay="autoplay" indicator-position="none" arrow="always" :interval="9000">
					<el-carousel-item v-for="(item, index) in $store.state.navShow == true ? news.newsList :news.newsListE" :key="index" data-aos="fade-right"
						data-aos-duration="500">
						<img :src="item.thumb" :data-id="item.id" @click="newJumpPath(item.id)">
					</el-carousel-item>
				</el-carousel>
				<div class="indexNewsConText" v-for="(item, index) in $store.state.navShow == true ? news.newsList :news.newsListE" :key="index">
					<div class="" v-if="index == newbBannerId" :data-id="item.id" @click="newJumpPath(item.id)">
						<div class="indexNewsConTitle" data-aos="fade-right" data-aos-duration="500">{{item.title}}
						</div>
						<div class="indexNewsContentText" data-aos="fade-right" data-aos-duration="500">{{item.content}}
						</div>
						<div class="timeIndicator">
							<div class="indexNewsContentTime">
								{{item.inputtime}}
							</div>
							<div class="indexNewsContentIndicator">
								<div v-for="(item, index) in $store.state.navShow == true ? news.newsList :news.newsListE" :key="index"
									:class="['Indicator_1','Indicator' , index==newbBannerId? 'IndicatorColor' : 'a' ]">
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
			<div class="indexVideo" data-aos="fade-right" data-aos-duration="500">
				<!-- 视频 -->
				<video-player class="vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="$store.state.navShow == true ? playerOptions:playerOptionsE ">
				</video-player>
			</div>

			<div class="marginGroup">
				<div class="marginGroupImg">
					<img :src="Image.MarginGroup" class="marginGroupImg_1">
				</div>
				<div class="marginGroupText" data-aos="fade-right" data-aos-duration="500">
					<div class="marginGroupTitle_1 marginGroupTitle">Margin Group</div>
					<div class="marginGroupTitle_2 marginGroupTitle"> {{
                $store.state.navShow == true
                  ? "全球商贸物流综合服务专家"
                  : "Global business logistics comprehensive service expert"
              }}</div>
					<div class="marginGroupCons" v-html="$store.state.navShow == true ? aboutUsText:aboutUsTextE">
						{{$store.state.navShow == true ?  'Margin Group（简称：MG集团）总部坐落于俄罗斯圣彼得堡，是一家致力于为中俄、西欧等国家和地区的国际商贸企业提供国际物流、进出口贸易、报关清关、供应链等服务的大型跨国集团企业。' : textEnt}}
					</div>
					<div class="marginGroupBott" @click="$router.push('/about')">
						<span>{{$store.state.navShow == true ? '了解详情' :'Learn more'}}</span>
						<img src="../assets/Index/details.png">
					</div>
				</div>
				<div class="marginGroupIoco" data-aos="fade-top" data-aos-duration="500">
					<div class="marginGroupIocoCon" v-for="(item, index) in Image.businessDetails" :key="index">
						<img :src="item.img" :style="'width:' + item.imgW + 'px; height:' + item.imgW + 'px;'">
						<div class="">{{$store.state.navShow == true ? item.title : item.titleE}}</div>
					</div>
				</div>
			</div>

			<module-title :title="$store.state.navShow == true ? '合作伙伴':'Cooperative partner'" EnglishTitle="cooperation"></module-title>
			<div class="cooperation">
				<div class="cooperationImg" data-aos="flip-left">
					<img v-for="(item, index) in Image.cooperationImgList" :key="index" :src="item.image"
						:name="item.name" :url="item.url" @click="cooperation(item.url)">
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import Header from "@/components/header.vue";
	// 引入模块标题组件
	import ModuleTitle from '../components/ModuleTitle.vue'
	export default {
		components: {
			Header,
			ModuleTitle
		},
		data() {
			return {
				textEnt:'Margin Group (Abbreviation: MG Group) is headquartered in St. Petersburg, Russia. It is a large multinational group dedicated to providing international logistics, import and export trade, customs clearance, supply chain and other services for international business enterprises in China, Russia, Western Europe and other countries and regions.At present, 4 branches have been established in Moscow, Vladivostok, Novorossiysk and Belarus; 5 branches have been established in Shanghai, Hebei, Shenzhen, Hainan and Hong Kong in China.The overseas warehouse built by MG Group in Moscow, Russia is recognized as "Hebei Province Public Overseas Warehouse"; it has stable international transportation routes and multimodal transportation experience in Russia, and has a professional freight fleet composed of more than 800 trucks and a professional customs declaration team; In 2021, the first China-Europe international train in Hebei Province that directly connects to Germany will be successfully opened, and the map of the train has been issued.MG Group will grasp the complementarity between supply and demand, integrate domestic long-term cooperative customer resources, and form a cluster of industrial chains such as production, processing, transportation, and life services.',
				newbBannerHeight: 250, // 新闻轮播图高度,
				newbBannerId: 0, // 新闻轮播图id,
				pageScrollTop: 0,
				c1Image: require('../assets/Index/c1.png'),
				c2Image: require('../assets/Index/c2.png'),
				c1Image_E: require('../assets/Index/c1_E.png'),
				c2Image_E: require('../assets/Index/c2_E.png'),
				Image: {
					service: {
						CentralRailway: {
							default: require('../assets/Index/a1_1.jpg'),
							highlight: require('../assets/Index/a1_2.jpg')
						}, //  中欧铁路线
						OceanRail: {
							default: require('../assets/Index/a2_1.jpg'),
							highlight: require('../assets/Index/a2_2.jpg')
						} //  海铁联运		
					}, //  国际物流服务

					serviceE: {
						CentralRailway: {
							default: require('../assets/Index/a1_1_E.jpg'),
							highlight: require('../assets/Index/a1_2_E.jpg')
						}, //  中欧铁路线
						OceanRail: {
							default: require('../assets/Index/a2_1_E.jpg'),
							highlight: require('../assets/Index/a2_2_E.jpg')
						} //  海铁联运		
					}, //  国际物流服务

					blueArrows: require('../assets/Index/blueArrows.png'), //  蓝色箭头
					transportation: require('../assets/Index/transportation.jpg'), //  中俄运输
					MarginGroup: require('../assets/Index/marginGroup.png'), //  全球商贸物流综合服务专家
					businessDetails: [{
							id: 1,
							img: require('../assets/Index/logistics.png'),
							title: '国际物流',
							titleE: 'International logistics',
							imgW: '32.5',
							imgH: '31',
						},
						{
							id: 2,
							img: require('../assets/Index/trade.png'),
							title: '进出口贸易',
							titleE: 'Import and export trade',
							imgW: '32.5',
							imgH: '30.5',
						},
						{
							id: 3,
							img: require('../assets/Index/customsClearance.png'),
							title: '报关清关',
							titleE: 'Customs clearance',
							imgW: '30.5',
							imgH: '30.5',
						},
						{
							id: 4,
							img: require('../assets/Index/supplyChain.png'),
							title: '供应链',
							titleE: 'Supply chain',
							imgW: '30',
							imgH: '30.5',
						},
					], //业务详情
					cooperationImgList: [{
							id: 1,
							image: require('../assets/Index/cooperation/000.jpg'),

						},
						{
							id: 2,
							image: require('../assets/Index/cooperation/001.jpg'),

						},
						{
							id: 3,
							image: require('../assets/Index/cooperation/002.jpg'),

						},
						{
							id: 4,
							image: require('../assets/Index/cooperation/003.jpg'),

						},
						{
							id: 5,
							image: require('../assets/Index/cooperation/004.jpg'),

						},
						{
							id: 6,
							image: require('../assets/Index/cooperation/005.jpg'),

						},
						{
							id: 7,
							image: require('../assets/Index/cooperation/006.jpg'),

						},
						{
							id: 8,
							image: require('../assets/Index/cooperation/007.jpg'),
						},
						{
							id: 9,
							image: require('../assets/Index/cooperation/008.jpg'),
						},

					]
				},
				autoplay: true,
				mapRouteList: [{
						title: '中欧铁路线',
						text: 'MG集团顺利开通河北省首个​直通德国国际班列',
						id: '1',
					},
					{
						title: '海铁联运',
						text: '拥有专业化管理团队和精细化运营模式',
						id: '2',
					},
				],
				mapRouteListE: [{
						title: 'China-Europe Railway Line',
						text: 'MG Group successfully opened the international trains from Hebei Province to Germany to carry outbound trains from multiple ports.',
						id: '1',
					},
					{
						title: 'Sea-rail combined transport',
						text: 'Have a professional management team and a refined operation model',
						id: '2',
					},
				],
				touchInfo: {
					state: false,
					direction: false, //  方向
					percentage: 0, //  国际物流服务 - 高亮展示百分比
					controlWidth: 20, //  控件的宽度
					parentNodeWidth: 0, //  父节点的宽度
					controlDistance: 0, //  控件距离父节点的距离
					pointerPosition: {
						start: 0, //  开始
						present: 0 //  当前
					} //  鼠标指针的水平位置
				}, //  国际物流服务 - 触控参数
				// 新闻中心
				news: {
					left: {
						// title: '2021年11月13日，MG＋冀欧号丨 “稳健高效” 中欧班列6月28日第四班发出！', //  标题
						// content: '本次恳谈会由河北省人民政府外事办公室、河北省人民对外友好协会和邯郸市人民政府共同主办，旨在进一步推进国际友好城市交流及务实合作，人民对外友好协会和邯郸市人民政府共同主办', //  内容
						// src: require('../assets/home/news_001.jpg'), //  图片
						// time: '11-13' //  时间
					}, //  左侧新闻头条
					newsList: [], //  新闻列表
					newsListE: [] //  新闻列表
				},
				autoplay1: false,
				// 视频资源
				playerOptions: {
					height: '150', //  播放器高度
					// playbackRates: [0.7, 1.0, 1.5, 2.0], //  播放速度
					autoplay: false, //  如果为 true，浏览器准备好就会立刻播放
					muted: false, //  关闭静音
					loop: false, //  禁止视频结束后重新开始播放
					preload: 'auto', //  立刻加载视频
					language: 'zh-CN',
					// aspectRatio: '16:9',    //  视频比例
					// fluid: true,    //  按照比例缩放视频，适应播放器
					sources: [{
						type: 'video/mp4', //  视频格式
						src: 'http://vjs.zencdn.net/v/oceans.mp4' //  视频地址
					}],
					// poster: require('../assets/home/news_video.jpg'), //  视频封面
					notSupportedMessage: '此视频暂无法播放，请稍后再试', //  无法播放时的错误信息
					controlBar: {
						timeDivider: true,
						durationDisplay: true,
						remainingTimeDisplay: true,
						fullscreenToggle: true, //  全屏按钮
					}, //  控件
				},
				playerOptionsE: {
					height: '150', //  播放器高度
					// playbackRates: [0.7, 1.0, 1.5, 2.0], //  播放速度
					autoplay: false, //  如果为 true，浏览器准备好就会立刻播放
					muted: false, //  关闭静音
					loop: false, //  禁止视频结束后重新开始播放
					preload: 'auto', //  立刻加载视频
					language: 'zh-CN',
					// aspectRatio: '16:9',    //  视频比例
					// fluid: true,    //  按照比例缩放视频，适应播放器
					sources: [{
						type: 'video/mp4', //  视频格式
						src: 'http://vjs.zencdn.net/v/oceans.mp4' //  视频地址
					}],
					// poster: require('../assets/home/news_video.jpg'), //  视频封面
					notSupportedMessage: '此视频暂无法播放，请稍后再试', //  无法播放时的错误信息
					controlBar: {
						timeDivider: true,
						durationDisplay: true,
						remainingTimeDisplay: true,
						fullscreenToggle: true, //  全屏按钮
					}, //  控件
				},
				aboutUsText: '',
				aboutUsTextE: '',
				indexConsShow_1: true,
				indexConsShow_2: false,
			}
		},
		mounted() {
			// let num = 0;
			// setInterval(() => {
			// 	num += 1
			// 	if (this.touchInfo.percentage <= 100) {
			// 		this.touchInfo.percentage = num
			// 	}
			// }, 12)
			/**
			 * 新闻中心与关于我们 接口
			 * 罗锦炜
			 * 2021-12-2
			 */
			// http request 请求拦截器
			// instance.interceptors.request.use(
			// config => {
			// 	config.headers['Content-Type'] = 'text/plain'
			// 	return config
			// }, err => {
			// 	return Promise.reject(err)
			// }
			// )
			
			this.$axios.get('/api/Index/newsAndAbout',{
				headers:{
					'Content-Type' : 'text/plain'
				}
			}).then((res) => {
					if (res.data.code === 1) {
						console.log('首页新闻中心与关于我们', res.data.data)
						// 关于我们内容
						this.aboutUsText = res.data.data.about

						// 新闻中心视频
						this.playerOptions.sources[0].src = res.data.data.video

						// 新闻中心内容
						// 新闻左侧展示新闻列表的第一项
						this.news.left = res.data.data.news[0]
						console.log('左边新闻=>', this.news.left)
						// 新闻中心的每一项
						this.news.newsList = res.data.data.news.map(item => {
							console.log('新闻中心内容', item)
							return item
						})
					} else {
						this.$message({
							showClose: true,
							message: '新闻中心与关于我们,' + res.data.msg,
							type: 'error'
						})
					}
				}),

			this.$axios.get('/apien/Index/newsAndAbout',{
			headers:{
				'Content-Type' : 'text/plain'
			}
			}).then((res) => {
					if (res.data.code === 1) {
						console.log('首页新闻中心与关于我们', res.data.data)
						// 关于我们内容
						this.aboutUsTextE = res.data.data.about

						// 新闻中心视频
						this.playerOptionsE.sources[0].src = res.data.data.video

						// 新闻中心内容
						// 新闻左侧展示新闻列表的第一项
						this.news.left = res.data.data.news[0]
						console.log('左边新闻=>', this.news.left)
						// 新闻中心的每一项
						this.news.newsListE = res.data.data.news.map(item => {
							console.log('新闻中心内容', item)
							return item
						})
					} else {
						this.$message({
							showClose: true,
							message: '新闻中心与关于我们,' + res.data.msg,
							type: 'error'
						})
					}
				}),
				/**
				 * 友情链接与合作公司地址 接口
				 * 罗锦炜
				 * 2021-12-3
				 */
				this.$axios.get('/api/Index/linksAndAddress').then(res => {
					console.log('友情链接与合作公司地址', res.data)
					if (res.data.code === 1) {
						// 合作伙伴
						this.Image.cooperationImgList = res.data.data.links.map(item => {
							// console.log('合作伙伴=>',item)
							return item
						})
						// console.log('this.Image.Partner',this.Image.Partner)
					} else {
						this.$message({
							showClose: true,
							message: '首页轮播图' + res.data.msg,
							type: 'error'
						})
					}
				})

			// 监听页面向下滚动的距离
			// window.addEventListener('scroll', e => {
			// 	// console.log("e",window.pageYOffset)
			// 	this.pageScrollTop = window.pageYOffset
			// 	console.log('Index', window.pageYOffset);
			// }, true) // 监听滚动事件
			this.switchControlDirection(true);

		},
		methods: {
			/**
			 * 切换控件方向
			 * 罗锦炜
			 * 2021-12-2
			 */
			switchControlDirection(state) {
				console.log('12312312312');
				// 获取相关参数
				const {
					direction,
					percentage
				} = this.touchInfo
				console.log('state', state);
				console.log('direction', direction);
				console.log(percentage, 'percentage')
				// 检测是否有必要更新
				if (direction !== state) {
					this.touchInfo.direction = state
					// 反转百分比
					// this.touchInfo.percentage = 100 - percentage

					// 逐渐递增更新百分比
					this.touchInfo.percentage = 0
					let soleInitPercentage = null
					clearInterval(soleInitPercentage)
					console.log('clearInterval(soleInitPercentage)', clearInterval(soleInitPercentage));
					soleInitPercentage = setInterval(() => {
						this.touchInfo.percentage += 1
						if (this.touchInfo.percentage >= 100) {
							console.log(this.touchInfo.percentage);
							clearInterval(soleInitPercentage)
							soleInitPercentage = null
						}
					}, 12)
				}

			},

			/**
			 * 控件 - 触摸开始
			 * 罗锦炜
			 * 2021-12-2
			 */
			touchStart(event) {
				console.log('触摸开始', event);
				// 保存父节点的宽度
				this.touchInfo.parentNodeWidth = this.$refs.serviceContentCenter.offsetWidth
				console.log('this.$refs', this.$refs.serviceContentCenter.offsetWidth)
				// 保存控件距离父节点的距离
				this.touchInfo.controlDistance = this.$refs.highlightControl.offsetLeft
				// 获取鼠标指针的水平位置
				this.touchInfo.pointerPosition.start = event.targetTouches[0].clientX
				// 触摸中回调
				document.addEventListener('touchmove', this.touchMove)
				document.addEventListener('touchend	', this.touchOver)
				// 触摸结束回调
				document.onmouseup = this.touchOver
				// 触摸开始
				this.touchInfo.state = true
				// console.log("触摸开始：", this.touchInfo)
			},

			/**
			 * 控件 - 触摸移动中
			 * 罗锦炜
			 * 2021-12-2
			 */
			touchMove(event) {
				console.log('移动中');
				console.log(event);
				// 检测是否已经开始
				if (this.touchInfo.state) {
					// 获取鼠标开始的位置
					const {
						parentNodeWidth,
						controlWidth,
						percentage,
						direction,
						controlDistance,
						pointerPosition: {
							start
						}
					} = this.touchInfo
					// 获取鼠标指针此时的位置
					this.touchInfo.pointerPosition.present = event.targetTouches[0].clientX
					console.log('this.touchInfo.pointerPosition.present', this.touchInfo.pointerPosition.present);
					// 获取鼠标指针移动的距离
					const distance = event.targetTouches[0].clientX - start
					console.log('distance', distance);
					// 获取计算后的滑块位置
					let calculateDistance = null
					calculateDistance = controlDistance + distance + controlWidth
					console.log('calculateDistance', calculateDistance);
					// 判断滑块的距离是否大于或小于限度
					if (calculateDistance > parentNodeWidth) {
						calculateDistance = parentNodeWidth
					} else if (calculateDistance < 0) {
						calculateDistance = 0
					}
					// 更新百分比
					let solePercentage = Number((calculateDistance / parentNodeWidth).toFixed(2)) * 100
					console.log('solePercentage', solePercentage);
					// 根据当前方向更新实际百分比
					solePercentage = direction ? solePercentage : (100 - solePercentage)
					if (solePercentage !== percentage) {
						this.touchInfo.percentage = solePercentage
					}
				}

			},

			/**
			 * 控件 - 触摸结束
			 * 罗锦炜
			 * 2021-12-2
			 */
			touchOver(event) {
				// 结束 触摸中回调
				document.removeEventListener('touchmove', this.touchMove)
				// 结束 触摸结束回调
				document.onmouseup = null


				// 触摸结束
				this.touchInfo.state = false
				console.log("触摸结束：", this.touchInfo)
			},
			/**
			 * 控件 - 触摸结束
			 * 罗锦炜
			 * 2021-12-2
			 */
			touchOver1(event) {
				// 结束 触摸中回调
				document.removeEventListener('touchmove', this.touchMove)
				// 结束 触摸结束回调
				document.onmouseup = null
				// 触摸结束
				this.touchInfo.state = false
				console.log("触摸结束：", this.touchInfo)
			},

			/**
			 * 监听切换
			 * 罗锦炜
			 * 2021-12-02
			 * */
			indexCons(id) {
				console.log('监听切换', id);
				if (id == 0) {
					this.indexConsShow_1 = true;
					this.indexConsShow_2 = false;
					this.switchControlDirection(true);
				} else {
					this.indexConsShow_1 = false;
					this.indexConsShow_2 = true;
					this.switchControlDirection(false);
				}
			},
			/**
			 * 切换内容
			 * 罗锦炜
			 * 2021-12-02
			 * */
			setActiveItem(num) {
				this.$refs.carousel.next(num)
			},
			/**
			 * 新闻轮播
			 * 罗锦炜
			 * 2021-12-3
			 * */
			newBusiness(id) {
				this.newbBannerId = id;
				console.log(id);
			},
			cooperation(url) {
				window.open(url, '_blank') // 打开新的窗口
			},

			/**
			 * 新闻跳转
			 * 罗锦炜
			 * 2021-12-08
			 * */
			newJumpPath(id) {
				this.$router.push({
					path: '/newsDetail',
					query: {
						newId: id
					}
				})
			},

			/**
			 * 地图跳转
			 * 刘嘉鑫
			 * 2021-12-10
			 */
			JupmPath() {
				if (this.indexConsShow_1 == true) {
					this.$router.push({
						path: '/chinaEuropeTrain',
					})
				}
				if (this.indexConsShow_2 == true) {
					this.$router.push({
						path: '/chinaEuropeOceanShipping',
					})
				}
			},
		}

	}
</script>
<style lang="less">
	// 国际物流服务
	.InternationalLogisticsService {}

	.indexConsShow_Img {
		width: 96%;
		margin: 0 1.5%;
		margin-top: -2rem;
		margin-bottom: 2.3125rem;
	}
</style>
<style lang="less">
	.Index {
		background-color: #FFFFFF;
	}

	.indexCons {
		width: 100%;
		height: auto;

		.indexConsTop {
			.el-carousel__item:nth-child(2n) {
				background-color: #FFF !important;
				height: 80px;
			}

			.el-carousel__item:nth-child(2n+1) {
				background-color: #FFF !important;
				height: 80px;
			}

			.el-carousel__container {
				height: 85px;
			}

			& .el-carousel__arrow {
				border: none;
				outline: 0;
				padding: 10px;
				margin: 0;
				height: 15px;
				width: 10px;
				cursor: pointer;
				transition: .3s;
				border-radius: 50%;
				background-color: rgba(255, 255, 255, 0);
				color: #FFF;
				position: absolute;
				top: 50%;
				z-index: 10;
				transform: translateY(-50%);
				text-align: center;
				font-size: 12px;
			}

			.el-carousel__arrow--right {
				right: 30px !important;
				display: block !important;
			}

			.el-carousel__arrow--left {
				left: 30px !important;
				display: block !important;
			}

			.el-carousel__arrow:hover {
				background-color: #FFF0;
			}

		}


		& .indexConsTitle {
			width: 100%;
			display: flex;
			// align-items: center;
			justify-content: center;
			// margin-bottom: 20px;
			// margin-top: 24px;

			.indexConsTitleText {
				.indexConsTitleText_1 {
					font-size: 15px;
					font-family: Microsoft YaHei;
					font-weight: bold;
					color: #2E67B1;
					margin-bottom: 9px;
				}

				.indexConsTitleText_2 {
					font-size: 10px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #999999;
					width: 60%;
    				margin: 0 auto;
				}

			}

			img {
				width: 7px;
				height: 11px;
				margin: 0 9.5px;
			}

		}
	}


	.indexConsImg {
		// width: 100%;
		// margin-bottom: 20px;
		width: 100%;
		height: 35vh;
		padding: 80px 0;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		--banner-width: 43vh;

		// 内容区域
		.serviceContent {
			width: var(--banner-width);
			height: calc(100% - 120px);
			display: flex;
			align-items: center;
			justify-content: center;

			.serviceContentCenter {
				font-size: 0;
				position: relative;
				--highPercentage: 0%; //  高亮距离百分比

				&>.imageContent {
					&>.el-image {
						width: var(--banner-width);
					}
				}

				&>.highlightBanner {
					position: absolute;
					width: var(--highPercentage);
					max-width: 100%;
					height: 100%;
					top: 0;
					overflow: hidden;

					&.positive {
						left: 0;

						&>.el-image {
							left: 0;
						}
					}

					&.reverse {
						right: 0;

						&>.el-image {
							position: absolute;
							right: 0;
						}
					}
				}

				// 高亮控件
				.highlightControl {
					width: 50px;
					height: 100%;
					// background-color: rgba(255, 255, 255, .5);
					position: absolute;
					top: 0;
					display: flex;
					align-items: center;
					z-index: 10;
					justify-content: center;

					&.positive {
						left: calc(var(--highPercentage) - 27px);

						& .TouchTheBlock {
							// right: -26px;
						}
					}

					&.reverse {
						right: calc(var(--highPercentage) - 27px);

						& .TouchTheBlock {
							// left: -26px;
						}
					}

					// 触摸块
					.TouchTheBlock {
						width: 50px;
						// height: 100%;
						// min-width: 50px;
						height: 100%;
						// background-color: #FFF;
						margin-top: calc(50% - 25px);
						// border-radius: 50%;
						position: relative;
						display: flex;
						align-items: center;
						justify-content: center;
						cursor: pointer;
						user-select: none; //  不允许内容被选中
						-webkit-tap-highlight-color: transparent;

						&>.el-image:first-of-type {
							transform: rotate(-360deg);
							margin-right: 3px;
						}

						&>.el-image:last-of-type {
							transform: rotate(-360deg);
							margin-left: 3px;
						}

						&:before {
							// content: '';
							// display: inline-block;
							// position: absolute;
							// width: 140%;
							// height: 140%;
							// top: -20%;
							// left: -20%;
							// z-index: -1;
							// border-radius: 50%;
							// background-color: rgba(255, 255, 255, .5);
							// box-shadow: rgba(0, 0, 0, 0.15) 0 0 30px 5px;
						}
					}
				}

				// 切换层
				.SwitchLayer {
					width: 100%;
					height: 100%;
					position: absolute;
					top: 0;
					left: 0;
					z-index: 5;

					.SwitchLayerCenter {
						width: 100%;
						height: 100%;
						position: relative;

						&>div {
							position: absolute;
							cursor: pointer;
						}

						// 中欧铁路线
						.CentralRailway {
							width: calc(var(--banner-width) * .237);
							height: calc(var(--banner-width) * .046);
							left: calc(var(--banner-width) * .01);
							top: 0;
						}

						// 海铁联运
						.OceanRail {
							width: calc(var(--banner-width) * .2);
							height: calc(var(--banner-width) * .06);
							right: calc(var(--banner-width) * .07);
							bottom: calc(var(--banner-width) * .003);
						}
					}
				}
			}
		}

		& .indexConsShow {
			width: 100%;

			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	// 中俄运输
	.TransportationBetweenChinaAndRussia {
		width: 100%;
		height: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #FFF;
		position: relative;
		margin: 0 0 30px 0;
		z-index: 1;

		&>.banner {
			width: 100%;
			height: 100%;
			position: absolute;
			z-index: -1;

			.el-image {
				width: 100%;
				height: 100%;
			}
		}

		.transportationContent {
			&>h1 {
				font-size: 17px;
			}

			&>p {
				font-size: 12px;
				word-break: break-word;//文本超出 自动换行
				margin: 0 auto;
				margin-top: 0.5rem;
				margin-bottom: 25.5px;
				padding: 0 20px
			}

			.el-button {
				padding-left: 30px;
				padding-right: 30px;
				border-color: #2E67B1;
				background-color: #2E67B1;
			}
		}
	}

	//新闻
	.indexNewsCon {
		& .el-carousel__arrow {
			// 轮播图按钮样式
			width: 1.5rem;
			height: 3rem;
			border-radius: 0;
			background-color: rgba(0, 0, 0, .5);

			&.el-carousel__arrow--left {
				left: 0px;
			}

			&.el-carousel__arrow--right {
				right: 0px;
			}
		}



		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-top: 1.5rem;
		border-bottom: 1px solid rgba(204, 204, 204, .6);
		margin-bottom: 2.1rem;

		.headerBanner {
			width: 92%;
			// height: 15rem;
			margin-bottom: 10px;
		}

		.indexNewsConText {
			width: 92%;
			justify-content: space-between;

			.indexNewsConTitle {
				font-size: .9rem;
				font-family: Microsoft YaHei;
				font-weight: 600;
				color: #333333;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				text-align: initial;
				margin-bottom: .93rem;
			}

			.indexNewsContentText {
				font-size: .75rem;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #999999;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				text-align: initial;
				margin-bottom: 1.75rem;
			}

			.timeIndicator {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: .8rem;

				.indexNewsContentTime {
					font-size: 1.3rem;
					font-family: AkzidenzGroteskBQ;
					font-weight: 600;
					color: #999999;
				}

				.indexNewsContentIndicator {
					display: flex;

					.Indicator {
						background-color: #CCCCCC;
						width: 8px;
						height: 8px;
						border-radius: 50%;
					}

					.Indicator:nth-child(2) {
						margin: 0 .625rem;
					}

					.IndicatorColor {
						background-color: #2E67B1;
					}
				}
			}



		}

	}

	//视频
	.indexVideo {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 3rem;

		.vjs-custom-skin {
			width: 92%;

			// height: 9rem;
			.vjs-big-play-button {
				font-size: 1rem;
			}
		}
	}

	.marginGroup {
		width: 100%;
		height: 22.9rem;
		position: relative;
		margin-bottom: 2.4rem;

		&>div {
			width: 100%;
			position: absolute;
		}

		.marginGroupImg {
			width: 100%;
			height: 100%;

			.marginGroupImg_1 {}

			&>img {}
		}

		.marginGroupText {
			width: 93%;
			top: 13.61%;
			padding-left: .96rem;

			&>div {
				text-align: left;
			}

			.marginGroupTitle_1 {
				font-size: .96rem;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #FFFFFF;
			}

			.marginGroupTitle_2 {
				font-size: 1rem;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #FFFFFF;
				margin-top: .5rem;
				margin-bottom: 1rem;
			}

			.marginGroupCons {
				width: 85%;
				height: 70%;

				&>p:nth-child(1) {
					font-size: .82rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #FFFFFF;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 4;
					-webkit-box-orient: vertical;
				}

				&>p:nth-child(2) {
					display: none;
				}

				&>p:nth-child(3) {
					display: none;
				}

			}
		}

		.marginGroupBott {
			display: flex;
			justify-content: center;
			align-items: center;
			padding: .5rem .7rem;
			border-radius: 5rem;
			background-color: rgba(46, 103, 177, 1);
			width: 5.6rem;
			margin-top: 2.4rem;

			&>img {
				width: 4px;
				height: 8px;
				margin-left: 7px;
			}

			&>span {
				font-size: .62rem;
				font-family: SourceHanSansSC;
				font-weight: 400;
				color: #FFFFFF;
			}
		}

		.marginGroupIoco {
			bottom: 4%;
			width: 100%;
			display: flex;
			justify-content: space-evenly;
			align-items: center;

			.marginGroupIocoCon {
				// &>img {
				// 	width: 2.5125rem;
				// 	height: 2.5125rem;
				// }

				&>div {
					font-size: 0.625rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #F8F8F8;
				}
			}
		}
	}

	.cooperation {
		width: 100%;
		margin-bottom: 2.5rem;

		.cooperationImg {
			width: 92%;
			margin: 0 4%;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			align-items: center;
			margin-top: 1.9rem;

			&>img {
				width: 6.5rem;
				height: 3.4rem;
				margin-bottom: .5rem;
			}
		}
	}
</style>
